import { render, staticRenderFns } from "./StockSlipImportExportBody.vue?vue&type=template&id=6bd44e9f"
import script from "./StockSlipImportExportBody.vue?vue&type=script&lang=js"
export * from "./StockSlipImportExportBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports